/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     mat-icon{vertical-align:middle}[_nghost-%COMP%]   mat-card[_ngcontent-%COMP%]{cursor:pointer;margin-bottom:10px;box-shadow:0 3px 6px 0 rgba(0,0,0,.08)!important}.solution[_ngcontent-%COMP%]{text-transform:capitalize;font-weight:500;font-stretch:normal;font-style:normal;letter-spacing:normal}.level[_ngcontent-%COMP%]{font-weight:600!important;font-stretch:normal!important;font-style:normal!important;letter-spacing:normal!important}"];
export { styles as styles };
